function parseUsdAmount(value: string): number {
  return Number(value.replace(/[$,]/g, "")) || 0
}

export function formatBuybackRatePercent(percent: number): string {
  if (!Number.isFinite(percent) || percent <= 0) {
    return "-"
  }

  const roundedPercent = Math.round(percent * 100) / 100
  return `${roundedPercent}%`
}

export function deriveBuybackRatePercent(
  marketValue: string,
  buybackOffer: string,
): number {
  const normalizedMarketValue = parseUsdAmount(marketValue)
  if (normalizedMarketValue <= 0) {
    return 0
  }

  return (parseUsdAmount(buybackOffer) / normalizedMarketValue) * 100
}
